
<img id="mascot" src="assets/mascot_ver4.PNG" alt="">

<ol id="title_home">
    <li>
        <h1>PURE</h1>
    </li>
    <li>
        <h1>PAZAAK</h1>
    </li>
</ol>
<ol>
    <li>
        <a routerLink="game">ИГРАТЬ</a>
    </li>
    <li>
        <a routerLink="rule">ПРАВИЛА</a>
    </li>
</ol>